module.exports = __webpack_public_path__ + "static/GFX_ebook2-9cb01a15a3e9e32143090c27c8892e35.png";